import React from "react"

const Enum = (value, index) => (
  <React.Fragment key={value}>
    <>
      {index !== 0 && ","}
      <code>{value}</code>
    </>
  </React.Fragment>
)

export default Enum
